// extracted by mini-css-extract-plugin
export var inner = "logo-module--inner--e3f6a";
export var logo = "logo-module--logo--0c2ad";
export var modalVideo = "logo-module--modal-video--04da5";
export var modalVideoBody = "logo-module--modal-video-body--8df4d";
export var modalVideoCloseBtn = "logo-module--modal-video-close-btn--3bd66";
export var modalVideoEffectExit = "logo-module--modal-video-effect-exit--e31f0";
export var modalVideoInner = "logo-module--modal-video-inner--10cc4";
export var modalVideoMovieWrap = "logo-module--modal-video-movie-wrap--0b5b9";
export var small = "logo-module--small--8a1ac";